"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const webview_app_1 = require("@/webview_app");
const api_1 = require("@/api");
const svgs_1 = require("@@/assets/svgs");
const functions_1 = require("@/common/functions");
const Button_1 = __importDefault(require("@mui/material/Button"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
function default_1({ pendingRef, orderId, reviewReplyForm, }) {
    const { watch, setValue } = reviewReplyForm;
    const replyPhotoThumb = watch('reply_photo_thumb');
    const [isUploading, setIsUploading] = (0, react_1.useState)(false);
    const disablePending = () => {
        pendingRef.current = false;
        setIsUploading(false);
    };
    const postReplyPhoto = (compressed) => __awaiter(this, void 0, void 0, function* () {
        const formData = new FormData();
        formData.append('image', compressed[0]);
        formData.append('thumb', compressed[1]);
        try {
            const response = yield (0, api_1.postFormData)(`/api/v1/order/${orderId}/review/image`, formData);
            if (response.data.success) {
                const { thumb_url, img_url } = response.data;
                setValue('reply_photo_thumb', thumb_url);
                setValue('reply_photo', img_url);
            }
        }
        catch (error) {
            console.log(error);
            throw new Error('upload image error');
        }
    });
    const uploadReplyPhoto = (fileList) => __awaiter(this, void 0, void 0, function* () {
        if (!pendingRef.current) {
            pendingRef.current = true;
            setIsUploading(true);
            const imageFile = fileList[0];
            try {
                const compressImage = yield new Promise((resolve, reject) => {
                    (0, functions_1.compressImageFile)({
                        imageFile,
                        maxWidth: 1500,
                        quality: 0.7,
                        onCompressSuccess: resolve,
                        onCompressError: () => reject(new Error('compress image error')),
                    });
                });
                const compressThumbnail = yield new Promise((resolve, reject) => {
                    (0, functions_1.compressImageFile)({
                        imageFile,
                        maxWidth: 480,
                        maxHeight: 500,
                        quality: 0.8,
                        onCompressSuccess: resolve,
                        onCompressError: () => reject(new Error('compress thumb error')),
                    });
                });
                const compressedFiles = yield Promise.all([compressImage, compressThumbnail]);
                yield postReplyPhoto(compressedFiles);
                disablePending();
            }
            catch (error) {
                console.log(error);
                disablePending();
                return;
            }
        }
    });
    return ((0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ component: "label", sx: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            rowGap: '2px',
            width: '56px',
            height: '56px',
            p: '7px',
            border: '1px solid var(--gray-10)',
            borderRadius: '8px',
            backgroundColor: 'var(--surface-bg) !important',
            color: 'var(--gray-40)',
        } }, { children: [isUploading ? ((0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 16, color: "secondary", thickness: 6 })) : ((0, jsx_runtime_1.jsx)(svgs_1.PlusWhiteCircleBlackSvg, { css: { width: '16px', height: '16px' } })), (0, jsx_runtime_1.jsxs)("span", Object.assign({ className: "caption1 gray-40" }, { children: ["(", !!replyPhotoThumb ? '1' : '0', "/1)"] })), (0, jsx_runtime_1.jsx)("input", { id: "review_reply_photo_input", type: "file", hidden: true, onChange: e => {
                    if (e.target.files)
                        uploadReplyPhoto(e.target.files);
                }, onClick: e => {
                    (0, webview_app_1.askPhotoPermissionsToWVA)('review_reply_photo_input', e);
                    e.currentTarget.value = '';
                } })] })));
}
exports.default = default_1;
